export const ANCHORS = {
	TARIFFS_BLOCK: 'tariffs',
};
